/**
 * Report a autocomplete suggestion click through event. A click through event is when a user
 * clicks on a suggestion within an autocomplete Dropdown.
 *
 * @param suggestionQuery String The suggestion query that was
 * clicked
 * @param position Number The position of the suggestion query. Zero based.
 * @param tag Array[String] Optional Tags which can be used to categorize
 * this click event
 */
export default function trackAutocompleteSuggestionClickThrough(suggestionQuery, position) {
  var tags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (this.debug) {
    var _console;
    // eslint-disable-next-line no-console
    (_console = console).log.apply(_console, ["Search UI: Action", "trackAutocompleteSuggestionClickThrough"].concat(Array.prototype.slice.call(arguments)));
  }
  var searchTerm = this.state.searchTerm;
  var events = this.events;
  events.emit({
    type: "AutocompleteSuggestionSelected",
    position: position,
    query: searchTerm,
    tags: tags,
    suggestion: suggestionQuery
  });
}